export default __webpack_public_path__ + "static/eric1-87fd4c4f821da0db0689ce931adb2d81.jpg";